import React, { useMemo } from 'react';
import { ServerMeta } from 'types/common';
import s from './s.module.less';
import ContentMgmtModal from './ContentMgmtModal';
import ContentItem from './ContentItem';
import {
    DataManager,
    TabDataManager,
} from '../../utils/dataUpdater';

import { TContentMgmt } from '../../type';

type Props = {
    hkUrl: string;
    condition?: ServerMeta;
    dataManager: DataManager;
};

const ContentMgmt = (props: Props) => {
    const { condition, dataManager, hkUrl } = props;
    const [contentModalVisible, setContentModalVisible] = React.useState(false);

    // 为contentMgmt tab创建独立的数据管理器
    const [contentTabManager] = React.useState<TabDataManager>(() => {
        return dataManager.createTabManager('contentMgmt');
    });

    // 从tab数据管理器获取contentMgmt数据
    const contentMgmtData = contentTabManager.getTabData('contentMgmt');

    const handleContentEdit = () => {
        setContentModalVisible(true);
    };

    const handleContentSave = async (data: TContentMgmt) => {
        try {
            // 使用tab数据管理器更新contentMgmt模块的数据
            contentTabManager.updateTabData('title', data.title || contentMgmtData.title);
            contentTabManager.updateTabData('summary', data.summary || contentMgmtData.summary);
            contentTabManager.updateTabData('medicalDisclaimerContent', data.medicalDisclaimerContent || contentMgmtData.medicalDisclaimerContent);
            contentTabManager.updateTabData('mainContent', data.mainContent || contentMgmtData.mainContent);

            // 保存到服务器
            await dataManager.saveDataToServer(
                () => {
                    setContentModalVisible(false);
                    // 可以在这里添加成功提示
                },
                (error: any) => {
                    console.error('Failed to save content:', error);
                    // 可以在这里添加错误提示
                },
            );
        } catch (error) {
            console.error('Error in handleContentSave:', error);
        }
    };

    return (
        <div className={s.wrap}>
            <div className={s.title}>
                Content management
            </div>

            <div className={s.contentSection}>
                <ContentItem
                    link={hkUrl}
                    content={contentMgmtData}
                    condition={condition}
                    onEdit={() => handleContentEdit()}
                />
            </div>

            {/* Content Management Modal */}
            <ContentMgmtModal
                link={hkUrl}
                visible={contentModalVisible}
                onCancel={() => setContentModalVisible(false)}
                onSave={handleContentSave}
                initialData={contentMgmtData}
                condition={condition}
            />
        </div>
    );
};

export default ContentMgmt;
